"use strict";
// This module turns an array of styled texts into a format that `console.log` understands
// For example:
//   console.log(
//     ...getConsoleLogArguments([
//       { text: "I'm red", style: ["color: red"] },
//       { text: "I'm bold & blue", style: ["color: blue", "font-weight: bold"] },
//     ])
//   );
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConsoleLogArguments = void 0;
function getConsoleLogArguments(logFragments, _a) {
    var _b = (_a === void 0 ? {} : _a).defaultStyle, defaultStyle = _b === void 0 ? ["font-size: 1.3em"] : _b;
    logFragments = applyOptions(logFragments, { defaultStyle: defaultStyle });
    return computeArguments(logFragments);
}
exports.getConsoleLogArguments = getConsoleLogArguments;
// We transform LogFragment[] to arguments for console.log.
// For example, from:
//   [
//     {
//       text: " I'm blue on a yellow background!",
//       style: ["background: yellow", "color: red"]
//     }
//   ]
// to:
//   console.log(...[
//     '%c I'm blue on a yellow background!',
//     'background: yellow; color: blue'
//   ]);
function computeArguments(logFragments) {
    var str = "";
    var styles = [];
    logFragments.forEach(function (_a) {
        var text = _a.text, style = _a.style;
        str += "%c" + text;
        styles.push(style.join(";"));
    });
    return __spreadArrays([str], styles);
}
function applyOptions(logFragments, _a) {
    var defaultStyle = _a.defaultStyle;
    logFragments.forEach(function (logFrag) {
        // Add defaultStyle
        logFrag.style = __spreadArrays((defaultStyle || []), (logFrag.style || []));
    });
    return logFragments;
}
//# sourceMappingURL=getConsoleLogArguments.js.map